import { useAuthClient } from "@/shared/lib/authClient";
import {
	AuthFormFeaturesLib,
	AuthFormFeaturesModel,
	AuthFormFeaturesUi
} from "@features/AuthFormFeatures";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

function SignUpWidget() {
	const signUpFormApi = useForm<AuthFormFeaturesModel.ISignUpSchema>({
		resolver: zodResolver(AuthFormFeaturesModel.signUpSchema)
	});
	const authClient = useAuthClient();
	const navigate = useRouter();
	return (
		<AuthFormFeaturesUi.AuthFormRoot formApi={signUpFormApi}>
			<AuthFormFeaturesUi.AuthFormContainer
				onSubmit={signUpFormApi.handleSubmit(
					AuthFormFeaturesLib.registerSubmitSignUpForm(
						signUpFormApi,
						navigate,
						authClient
					)
				)}
			>
				<AuthFormFeaturesUi.AuthFormHeader
					title="Create your account"
					subTitle="Enter your details below to create a new account"
				/>
				<div className="grid gap-6">
					<AuthFormFeaturesUi.AuthFormField
						control={signUpFormApi.control}
						name={"email"}
						type={"email"}
						DisplayName="Email"
					/>
					<AuthFormFeaturesUi.AuthFormField
						control={signUpFormApi.control}
						name={"password"}
						type={"password"}
						DisplayName="Password"
					/>
					<AuthFormFeaturesUi.AuthFormField
						control={signUpFormApi.control}
						name={"confirmPassword"}
						type={"password"}
						DisplayName="Confirm Password"
					/>
					<AuthFormFeaturesUi.SubmitAuthFormFeature>
						Sign up
					</AuthFormFeaturesUi.SubmitAuthFormFeature>
					<AuthFormFeaturesUi.SignUpAuthMethods />
					<AuthFormFeaturesUi.AuthFormErrorMessage />
				</div>
			</AuthFormFeaturesUi.AuthFormContainer>
		</AuthFormFeaturesUi.AuthFormRoot>
	);
}

export default SignUpWidget;
